import { FC, useEffect, useState } from 'react';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useSearchParams } from 'react-router';
import { cardBuy, getCard } from '../../shared/api/market';
import { GiftShop_Info } from '../../generated/mlmbox/types/gift_shop';
import Loader from '../../shared/ui/Loader/Loader';
import { checkW, errorIcon, prize } from '../../assets';
import MessageStick from '../../shared/ui/MessageStick/MessageStick';
import ShodawButton from '../../shared/ui/ShadowButton/ShodawButton';
import styles from './BuyCard.module.scss';
import PageHeader from '../../shared/ui/PageHeader/PageHeader';
import { cardWithdDraw } from '../../shared/api/market/card';

const BuyCard: FC = () => {
    const { cardId } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [card, setCard] = useState<GiftShop_Info>();
    const [address, setAddress] = useState('');
    const [pending, setPending] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        if (!cardId) return;

        getCard(Number(cardId))
            .then((res) => {
                if (res) {
                    setCard(res);
                } else navigate(`/card/${cardId}`);
            })
            .catch((e) => {
                console.log(e);
                navigate(`/card/${cardId}`);
            });
    }, []);

    async function handleClick() {
        if (!address || !card || !card.card) return;
        setPending(true);

        const response = await cardBuy({ id: card.card?.id, address });

        if (!response) {
            setPending(false);
            return;
        }

        navigate(`/card/${card.card.id}`);
    }

    async function handleClickW() {
        if (!address || !card || !card.card) return;
        setPending(true);

        const response = await cardWithdDraw({ id: card.card?.id, address });

        if (!response) {
            setPending(false);
            return;
        }

        navigate(`/card/${card.card.id}`);
    }

    return (
        <>
            {pending && (
                <div className="dis">
                    <Loader />
                </div>
            )}
            {card?.card && (
                <div className={styles.cardBuy}>
                    <PageHeader
                        title={t('g')}
                        closeBtn={() =>
                            searchParams.get('notransaction') ? navigate('/market') : navigate(`/card/${card.card?.id}`)
                        }
                    />
                    <div className={styles.info}>
                        <img
                            className={styles.img}
                            src={`${import.meta.env.VITE_API_URL}/${card.card.imageSrc}`}
                            alt=""
                        />

                        <div className={styles.data}>
                            <h1>{card.card.title}</h1>
                            <p>
                                <img
                                    src={prize}
                                    alt=""
                                />
                                {card.card.pointsNeeded}
                            </p>
                        </div>
                    </div>
                    <div
                        style={{ margin: '18px 0' }}
                        className="l2"></div>

                    <input
                        type="text"
                        placeholder="Укажите кошелек USDT BEP20"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                    />

                    <h2>
                        На кошелек поступит: <span>{Number(card.card.usdtPrice)} USDT</span>
                    </h2>

                    <div className={styles.m}>
                        <MessageStick
                            icon={errorIcon}
                            title="Средства отправленные на кошельки другой сети будут утеряны!"
                            bg="rgba(255, 78, 99, 0.05)"
                        />
                    </div>
                    <ShodawButton
                        style={{ opacity: !address ? 0.5 : 1 }}
                        shadow
                        icon={checkW}
                        title="Вывести средства"
                        onClick={() => {
                            if (card.card?.released) {
                                handleClickW();
                            } else {
                                handleClick();
                            }
                        }}
                    />
                </div>
            )}
        </>
    );
};

export default BuyCard;
